import styled from "styled-components";

export const Container = styled.div`
  .dropdown-menu{
    // height: 40rem;
    width: 35rem;
    overflow-y: auto;
  }
`;
